<script lang="ts" setup generic="T extends PejerTableNames">
import { AccessorKeyColumnDef, Row } from '@tanstack/vue-table'
import { usePejerBase } from '../../../stores/pejerData'
import { PejerTableNames, PejerTablesList } from '../../../types/base'
import FlexRenderedGroup from '../../FlexRenderedGroup.vue'
import TableCell from '../../ui/table/TableCell.vue'
import TableRow from '../../ui/table/TableRow.vue'

const props = defineProps<{
  row: Row<any>
  tableName: T
  columns: AccessorKeyColumnDef<PejerTablesList<T>>[]
  isExpanded: boolean
}>()
const store = usePejerBase()

const columnsGrouped = store.getGroups(props.tableName, props.columns)

const columnsGroupedLength = Object.keys(columnsGrouped).length

function beforeEnter(el) {
  el.style.height = '0'
}

function enter(el) {
  el.style.transition = 'height 0.3s ease-out'
  el.style.height = el.scrollHeight + 'px'
}

function afterEnter(el) {
  el.style.height = 'auto'
}

function beforeLeave(el) {
  el.style.height = el.scrollHeight + 'px'
}

function leave(el) {
  el.style.transition = 'height 0.3s ease-out'
  el.style.height = '0'
}

function afterLeave(el) {
  el.style.height = 'auto'
}
</script>

<template>
  <TableRow class="hover:bg-white min-h-0 p-0 m-0" :class="isExpanded ? 'border-b-2' : 'border-0'">
    <TableCell colspan="100" aria-colspan="100" class="p-0">
      <transition
        @before-enter="beforeEnter"
        @enter="enter"
        @after-enter="afterEnter"
        @before-leave="beforeLeave"
        @leave="leave"
        @after-leave="afterLeave"
      >
        <div
          v-if="isExpanded"
          class="overflow-hidden grid grid-cols-1 gap-x-4 gap-y-10 w-full mt-4 mb-6"
          :class="{ 'lg:grid-cols-2': columnsGroupedLength > 1 }"
        >
          <template v-for="(group, index) of columnsGrouped" :key="row.id + index">
            <div v-if="group.columns.length > 0">
              <FlexRenderedGroup :group="group" :item="row.original" />
            </div>
          </template>
        </div>
      </transition>
    </TableCell>
  </TableRow>
</template>
